import toast from 'react-hot-toast';

const notify = (message, { type = 'info', duration, position = 'top-right' } = {}) => {
    if (!message) return;

    const durationMs = duration || (type === 'error' ? 5000 : 3000);

    const config = {
        duration: durationMs,
        position,
    };

    switch (type) {
        case 'success':
            toast.success(message, config);
            break;
        case 'error':
            toast.error(message, config);
            break;
        case 'warning':
            toast(message, config);
            break;
        default:
            toast(message, config);
    }
};

// Helper methods
export const showSuccess = (message, options) => notify(message, { ...options, type: 'success' });
export const showError = (message, options) => notify(message, { ...options, type: 'error' });
export const showWarning = (message, options) => notify(message, { ...options, type: 'warning' });
export const showInfo = (message, options) => notify(message, { ...options, type: 'info' });

export default notify;
